var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container",attrs:{"id":"app"}},[_c('div',[_c('GlobalLoader'),_c('p',{staticClass:"mt-3 text-semibold"},[_vm._v("Please be patient ! We are setting up your organization")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }